import { render, staticRenderFns } from "./tqUnionRatio.vue?vue&type=template&id=db8fc458&scoped=true&"
import script from "./tqUnionRatio.vue?vue&type=script&lang=js&"
export * from "./tqUnionRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8fc458",
  null
  
)

export default component.exports